import { createSlice } from '@reduxjs/toolkit';

const getInitialTheme = () => {
  try {
    const saved = localStorage.getItem('theme');
    if (saved) return saved;
    return 'light';
  } catch {
    return 'light';
  }
};

const themeSlice = createSlice({
  name: 'theme',
  initialState: { mode: getInitialTheme() },
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === 'black' ? 'light' : state.mode === 'light' ? 'dark' : 'black';
      try { localStorage.setItem('theme', state.mode); } catch (_) {}
    },
    setTheme: (state, action) => {
      state.mode = action.payload;
      try { localStorage.setItem('theme', state.mode); } catch (_) {}
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
